
<nav class="navbar navbar-expand-md fixed-top navbar-dark " style="background-color: #212121;">
  <div class="btn-logo-container">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle" *ngIf="router.url.includes('/pages/')">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
    <a class="navbar-brand" routerLink="/">
      <img src="./assets/logo.png" width="120rem" alt="logo plugpoint">
    </a>
  </div>
  <div class="btn-toggler-container">
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarsExampleDefault"
      aria-controls="navbarsExampleDefault" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
  </div>

  <div class="collapse navbar-collapse" id="navbarsExampleDefault">
    <ul class="navbar-nav ml-auto">
      <li class="nav-item active">
        <button class="btn btn-link" (click)="navigateHome()"><i class="fas fa-home mr-1"></i>Home</button>
      </li>
      <ng-container *ngIf="auth.loggedIn === true && auth.access != 'none'">
        <li class="nav-item active" *nbIsGranted="['view', 'dashboard']">
          <button class="btn btn-link" (click)="navigateDashboard()"><i
              class="fas fa-chart-line mr-1"></i>Dashboard</button>
        </li>
      </ng-container>
      <!-- <ng-container *ngIf="auth.loggedIn === true && auth.access == 'none'">
        <li class="nav-item active">
          <button class="btn btn-link" (click)="navigateApp()"><i
            class="fas fa-mobile-alt mr-1"></i>App</button>
        </li>
      </ng-container> -->
      <li class="nav-item active">
        <ng-container *ngIf="auth.loggedIn === false">
          <button class="btn btn-link" (click)="auth.login()"><i
            class="fas fa-user mr-1"></i>Sign in</button>
        </ng-container>
        <div class="header-container">
          <nb-actions size="tiny" *ngIf="auth.loggedIn === true">
            <nb-action class="user-action">
              <nb-user [nbContextMenu]="userMenu" color="#F5D410" size="medium" [onlyPicture]="userPictureOnly" [name]="user?.name"
                [picture]="user?.picture">
              </nb-user>
            </nb-action>
          </nb-actions>
        </div>

      </li>
    </ul>
  </div>
</nav>